/* globals showModalError */
import React, { useState, useContext, useEffect, useRef } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";
import BqnContext from "common/BqnContext";
import styled from "styled-components";
import {doFileChange} from "./utils";
import ChooseInstance, { getSelectedBqn } from "views/Administration/common/ChooseInstance";

const WrapperFileInput = styled.div`
  display: flex;
  align-items: center;
  .license-file {
    width: 150px;
  }
`;

const PathDiv =styled.div`
  margin-left: 20px;
  font-family: "AllianceNo2-SemiBold" !important;
  font-size: 13px;
`

const FooterError =styled.div`
  width: 100%;
  text-align: left;
  margin-bottom: 10px;
`

const BrowseButton = styled.button`
  border: var(--color-grey300) 1px solid !important;
`
const FILE_INIT = "No file chosen";

const UploadCluster = () => {
  const {
    bqnId,
    loginBqnId
  } = useContext(BqnContext); 
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  const [path, setPath] = useState("")
  const fileInputRef = useRef(null);
  const [bqnSelected, setBqnSelected] = useState(getSelectedBqn(bqnId, loginBqnId));
  const [file, setFile] = useState();
  const [error, setError] = useState("");

  const doClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    return actions.recv("open-upload", function () {
      setBqnSelected(getSelectedBqn(bqnId, loginBqnId))
      setError("");
      setOpen(true);
      setFile(FILE_INIT);
      setPath("")
    });
  }, [bqnId]);

  const handleApply = () => {
    setError("");
    if(file===FILE_INIT){
      setError("PLEASE SELECT A FILE");
    } else {
      ifCl
      .run(`set license load ${path} bqn-id ${bqnSelected}`)
      .then((response) => {
        if (response === "") {
          actions.send("do-load");
          setOpen(false);
        } else {
          throw new Error(`%ERR-RESPONSE`);
        }
      })
      .catch((error) => {
        setError(`ERROR LOADING LICENSE: ${error}`);
      });
    }
  };

  const handleSaveFile = (response, path, name)=> {
    if (response.SaveAsFileResponse.code !== 0) {
      showModalError("Error saving file", response.SaveAsFileResponse.reason);
    } else {
      setFile(name);
      setPath(path);
    }
  }

  const handleFileChange = (event) => {
    const [file] = event.target.files;
    doFileChange(
      file,
      ifCl,
      handleSaveFile,
      () => setError("Problem reading file."),
      () => setError("Error loading license file.")
    );
  };

  const handleBrowseClick = () => {
    setError("")
    fileInputRef.current.click()
  }

  return open !== true ? null : (
    <Modal
      title="Load License"
      onClose={doClose}
      closeLabel="CANCEL"
      applyLabel="UPLOAD"
      onApply={handleApply}
      footerMessage={
        error ? (
          <FooterError className="color-red">{error}</FooterError>
        ) : null
      }
      content={() => (
        <div>
          <ChooseInstance
            action="license"
            selected={bqnSelected}
            setSelected={setBqnSelected}
          />
          <WrapperFileInput>
          <BrowseButton type="button" className="btn btn-link waves-effect" onClick={handleBrowseClick}>Browse...</BrowseButton>
          <PathDiv>{file}</PathDiv>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            
          </WrapperFileInput>
        </div>
      )}
    />
  );
};
export default UploadCluster;
